const FREE_EMAIL_DOMAINS = new Set([
  'aol.com',
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'outlook.com',
  'proton.me',
  'protonmail.com',
  'yahoo.com',
])

function slugifyCompany(company: string): string | null {
  const slug = company
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug || null
}

export function isFreeEmailDomain(domain: string): boolean {
  return FREE_EMAIL_DOMAINS.has(domain.trim().toLowerCase())
}

export function normalizeCompanyGroup(email: string, company?: string): string | null {
  const domain = email.trim().toLowerCase().split('@')[1] || ''
  if (domain && !isFreeEmailDomain(domain)) return domain
  return company ? slugifyCompany(company) : null
}
